export default __webpack_public_path__ + "static/media/Simple-Line-Icons.f1515a45.svg";